// -----------------  FETCH DEVICES -----------------
export const FETCH_DEVICES_LOADING = 'FETCH_DEVICES_LOADING';
export const FETCH_DEVICES_SUCCESS = 'FETCH_DEVICES_SUCCESS';
export const FETCH_DEVICES_ERROR = 'FETCH_DEVICES_ERROR';

// -----------------  SELECT DEVICES -----------------
export const SELECT_DEVICE = 'SELECT_DEVICE';
